import { usePagination } from '@hooks';

export type PendingProspectStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface PendingProspect {
  id: string;
  createdBy: string;
  usersCount: number;
  customerId: number;
  customerName: string;
  segmentName: string;
  companyCuit: string;
  filePath: string;
  fileName: string;
  status: PendingProspectStatus;
  resolvedBy: string | null;
  resolvedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PendingProspectsResponse {
  page: PendingProspect[];
  limit: number;
  offset: number;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  previousPage: number | null;
  nextPage: number | null;
}

interface GetPendingProspectsParams {
  params: object;
  setURLparams: () => void;
}

/**
 * Fetches pending prospect registrations paginated
 */
const useGetPendingProspects = ({ params, setURLparams }: GetPendingProspectsParams) => {
  const { data: paginatedData, ...props } = usePagination('/v3/prospect/pending', {
    params,
    setURLparams,
    paramKeys: ['page', 'limit', 'status', 'customerId'],
  });

  const data = paginatedData as PendingProspectsResponse | undefined;

  return { data, ...props };
};

export default useGetPendingProspects;
